// Featured collection 
(function FeaturedCollectionSlide() {
  let listElem = document.querySelectorAll('.collection__slider');
  listElem.forEach(( elem ) => {
    let dataItem = elem.getAttribute('data-class');
    let slideItem = document.querySelector(`[data-class=${dataItem}]`);
    if (slideItem) {
      let flkty = new Flickity( slideItem, {
        cellAlign: 'left',
        prevNextButtons: true,
        freeScroll: false,
        contain: true,
        wrapAround: true,
        pageDots: true
      });
    }
  })
})();


// Footer 
class CollapsibleContent extends HTMLElement {
  constructor(){
    super();
    this.headingMobile = this.querySelector('.collabsible__title--mobile');
    this.heading = this.querySelector('.collabsible__title');
    this.content = this.querySelector('.collabsible__content');
    let bodyWidth = document.querySelector('body').offsetWidth;

    if (this.headingMobile && bodyWidth < 750) {
      this.headingMobile.addEventListener('click', this.showContent.bind(this));
    }

    if (this.heading) {
      this.heading.addEventListener('click', this.showContent.bind(this));      
    }

  }

  showContent() {
    this.classList.toggle('active');
    if (this.content) {
      this.content.classList.toggle('active');
    }
  }
}

customElements.define('collapsible-content', CollapsibleContent);


// Header
const menuItems = document.querySelectorAll('.header__menu-item--child');
let isMegamenuHovered = false;
let isMenuItemHovered = false;

menuItems.forEach(menuItem => {
  const megamenu = menuItem.nextElementSibling;

  if (megamenu) {
    megamenu.addEventListener('mouseenter', () => {
      document.body.classList.add('header__active');
      megamenu.classList.add('active');
      menuItem.parentElement.classList.add('active');
      isMegamenuHovered = true;
    });

    megamenu.addEventListener('mouseleave', () => {
      isMegamenuHovered = false;
        if (!isMegamenuHovered && !menuItem.matches(':hover')) {
          document.body.classList.remove('header__active');
          megamenu.classList.remove('active');
          menuItem.parentElement.classList.remove('active');
        }
    });
  }

  menuItem.addEventListener('mouseenter', () => {
    if (megamenu) {
      document.body.classList.add('header__active');
      megamenu.classList.add('active');
      menuItem.parentElement.classList.add('active');
      isMenuItemHovered = true;
    }
  });

  menuItem.addEventListener('mouseleave', () => {
    if (megamenu) {
      if (!isMegamenuHovered && !megamenu.matches(':hover')) {
        document.body.classList.remove('header__active');
        megamenu.classList.remove('active');
        menuItem.parentElement.classList.remove('active');
      }   
    }
  });
});


// Collection 
class CollectionDescription extends HTMLElement {
  constructor(){
    super();
    this.buttonReadMore = this.querySelector('.js-read-more');
    this.buttonReadLess = this.querySelector('.js-read-less');
    this.collectionContent = this.querySelector('.collection__description--content');
    let heightContent;

    if ( document.querySelector('body').offsetWidth > 749) {
      heightContent = 118; //def: 48
    } else {
      heightContent = 118; //def: 118
    }    

    if (this.collectionContent.offsetHeight > heightContent ) {
      this.buttonReadMore.classList.add('active');
      this.collectionContent.classList.add('hide-content');
    }

    this.buttonReadMore.addEventListener('click', this.showContent.bind(this));
    this.buttonReadLess.addEventListener('click', this.hideContent.bind(this));
  }

  showContent() {
    this.collectionContent.classList.add('active');
    this.collectionContent.classList.remove('hide-content');
    this.buttonReadMore.classList.remove('active');
    this.buttonReadLess.classList.add('active');
  }

  hideContent() {
    this.collectionContent.classList.remove('active');
    this.buttonReadMore.classList.add('active');
    this.buttonReadLess.classList.remove('active');
    this.collectionContent.classList.add('hide-content');
  }

}

customElements.define('collection-desctiption', CollectionDescription);


// Product upsells 

(function ProductUpsellsSlide() {
  let listElem = document.querySelectorAll('.slide__upsells');
  listElem.forEach(( elem ) => {
    let flkty = new Flickity( elem, {
      cellAlign: 'left',
      prevNextButtons: true,
      freeScroll: false,
      contain: true,
      wrapAround: true,
      pageDots: true
    });

    let carouselStatus = elem.nextElementSibling;
    if (carouselStatus && carouselStatus.classList.contains('carousel-status')) {
      function updateStatus() {
        let slideNumber = flkty.selectedIndex + 1;
        carouselStatus.textContent = slideNumber + ' / ' + flkty.slides.length;
      }
      updateStatus();
      flkty.on( 'select', updateStatus );
    }
  });

  // Resize Flickity instances when collapsible opens (fixes layout for hidden sliders)
  document.querySelectorAll('.product__upsell--item > .collabsible__title').forEach(function(title) {
    title.addEventListener('click', function() {
      let parentCollapsible = title.closest('.product__upsell--item');
      if (!parentCollapsible) return;
      setTimeout(function() {
        parentCollapsible.querySelectorAll('.slide__upsells').forEach(function(slider) {
          let flktyInstance = Flickity.data(slider);
          if (flktyInstance) flktyInstance.resize();
        });
      }, 100);
    });
  });
})();


// Related Articles 

(function RelatedArticles() {
  let relatedProducts = document.querySelector('.template-article .section-featured-collection');
  let relatedArticles = document.querySelector('.relatedArticles');

  if ( relatedProducts && relatedArticles ) {
    relatedProducts.appendChild(relatedArticles);
  }

  let countArticles = Array.from(document.querySelectorAll('.relate-article__item')).length;
  let elem = document.querySelector('.relatedArticles__slider');

  if (elem && countArticles > 3 ) {
    elem.classList.remove('relatedArticles__grid');
    let flkty = new Flickity( elem, {
      cellAlign: 'left',
      prevNextButtons: false,
      freeScroll: false,
      contain: true,
      wrapAround: true,
      pageDots: true
    });
  }
})();


// Rich text collapsible
class CollapsibleRichtextDescription extends HTMLElement {
  constructor() {
    super();
    this.onToggleClick = this.onToggleClick.bind(this);
    this.textEl = null;
    this.contentEl = null;
    this.toggle = null;
    this.readMoreLabel = 'Read more';
    this.readLessLabel = 'Read less';
    this.fullHTML = '';
    this.collapsedHTML = '';
  }

  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.textEl = this.querySelector('.rich-text__text--expandable');
    this.contentEl = this.querySelector('.rich-text__text-content');
    this.toggle = this.querySelector('.rich-text__toggle');
    if (!this.textEl || !this.contentEl || !this.toggle) return;

    this.readMoreLabel = this.toggle.getAttribute('data-read-more-label') || this.readMoreLabel;
    this.readLessLabel = this.toggle.getAttribute('data-read-less-label') || this.readLessLabel;

    const wordCount = parseInt(this.dataset.collapseWordCount, 10);
    this.fullHTML = this.contentEl.innerHTML;
    this.collapsedHTML = wordCount > 0
      ? this.buildCollapsedHTML(this.contentEl, wordCount)
      : this.fullHTML;

    this.applyState();

    this.toggle.setAttribute('aria-expanded', 'false');
    this.toggle.addEventListener('click', this.onToggleClick);
  }

  disconnectedCallback() {
    if (this.toggle) {
      this.toggle.removeEventListener('click', this.onToggleClick);
    }
  }

  buildCollapsedHTML(sourceEl, maxWords) {
    const clone = sourceEl.cloneNode(true);
    let remaining = maxWords;
    let truncated = false;

    const walk = (node) => {
      const children = Array.from(node.childNodes);
      for (const child of children) {
        if (remaining <= 0) {
          child.remove();
          continue;
        }
        if (child.nodeType === Node.TEXT_NODE) {
          const text = child.textContent;
          const tokens = text.split(/(\s+)/);
          let used = 0;
          let out = '';
          for (const token of tokens) {
            if (/^\s+$/.test(token) || token === '') {
              out += token;
              continue;
            }
            if (remaining <= 0) {
              truncated = true;
              break;
            }
            out += token;
            remaining -= 1;
            used += 1;
          }
          child.textContent = out;
          if (used === 0 && remaining <= 0 && out.trim() === '') {
            child.remove();
          }
        } else if (child.nodeType === Node.ELEMENT_NODE) {
          walk(child);
        }
      }
    };

    walk(clone);

    if (truncated) {
      const lastTextNode = this.findLastTextNode(clone);
      if (lastTextNode) {
        lastTextNode.textContent = lastTextNode.textContent.replace(/\s+$/, '') + '…';
      } else {
        clone.appendChild(document.createTextNode('…'));
      }
    }

    return clone.innerHTML;
  }

  findLastTextNode(node) {
    for (let i = node.childNodes.length - 1; i >= 0; i--) {
      const child = node.childNodes[i];
      if (child.nodeType === Node.TEXT_NODE && child.textContent.trim() !== '') {
        return child;
      }
      if (child.nodeType === Node.ELEMENT_NODE) {
        const found = this.findLastTextNode(child);
        if (found) return found;
      }
    }
    return null;
  }

  applyState() {
    const isCollapsed = this.textEl.classList.contains('rich-text__text--collapsed');
    this.contentEl.innerHTML = isCollapsed ? this.collapsedHTML : this.fullHTML;
  }

  onToggleClick() {
    if (!this.textEl || !this.toggle) return;

    const isCollapsed = this.textEl.classList.toggle('rich-text__text--collapsed');
    this.toggle.textContent = isCollapsed ? this.readMoreLabel : this.readLessLabel;
    this.toggle.setAttribute('aria-expanded', String(!isCollapsed));
    this.applyState();
  }
}

if (!customElements.get('collapsible-richtext')) {
  customElements.define('collapsible-richtext', CollapsibleRichtextDescription);
}


